import { useRouter } from 'next/router';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getQuizDetails } from '@selectors/quizTaking';
import { programmeTypes } from '@constants/index';
import { emptyObject } from '@constants/empty';
import isEmptyObject from '@utils/isEmptyObject';

const useProgrammeType = () => {
  const router = useRouter();
  const {
    query: { quizUID }
  } = router;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));

  if (isEmptyObject(quizDetails)) {
    return emptyObject;
  }

  const isTestSeries =
    quizDetails?.collection?.programme?.programme_type ===
    programmeTypes.TESTSERIES;

  const isContest =
    quizDetails?.collection?.programme?.programme_type ===
    programmeTypes.CONTEST;

  const isFree = quizDetails?.collection?.programme?.is_special;

  return { isFree, isTestSeries, isContest };
};

export default useProgrammeType;
